<template>
    <section id="members" class="gradient" style="min-height: 400px; color:#FFFFFF">
        <mdb-container class="py-5">
            <mdb-row>
                <mdb-col md="6">
                    <h6 class="section-header-top">Team</h6>
                    <h2>WORCESTER POLYTECHNIC INSTITUTE</h2>
                    <hr class="hr-light"/>
                </mdb-col>
            </mdb-row>
            <mdb-row class="py-3 wpi-members">
                    <mdb-col lg="3" md="6" class="mb-lg-0 mb-5" v-for="member in memWPIPaginate"
                             :key="member.id">
                        <img v-if="member.dp!==null" :src="member.dp" alt="Avatar"
                             class="md-avatar rounded-circle size-1">
                        <img v-else :src="require('@/assets/members/dummy-user.jpg')" alt="Avatar"
                             class="md-avatar rounded-circle size-1">
                        <h5 class="font-weight-bold mt-4 mb-3">{{member.name}}</h5>
                        <p class="text-uppercase position">{{member.position}}</p>
                    </mdb-col>
            </mdb-row>
<!--            <jw-pagination :items="memWPI" @changePage="onChangePage"></jw-pagination>-->
<!--            <div v-for="item in memWPIPaginate" :key="item.id">{{item.name}}</div>-->
            <div class="text-center">
            <jw-pagination v-if="computedMemWPI.length" :pageSize="8" :items="computedMemWPI" @changePage="onChangePage"
                           :styles="customStyles" :labels="customLabels"></jw-pagination>
            </div>

            <mdb-row class="py-5">
                <mdb-col md="6">
                    <h6 class="section-header-top">Team</h6>
                    <h2>ARMY RESEARCH LABORATORY</h2>
                    <hr class="hr-light"/>
                </mdb-col>
            </mdb-row>
            <mdb-row class="py-3">
                <mdb-col lg="3" md="6" class="mb-lg-0 mb-5" v-for="(member,key) in this.$parent.membersARL" :key="key">
                    <img v-if="member.dp!==null" :src="member.dp" alt="Avatar"
                         class="md-avatar rounded-circle size-1">
                    <img v-else :src="require('@/assets/members/dummy-user.jpg')" alt="Avatar"
                         class="md-avatar rounded-circle size-1">
                    <h5 class="font-weight-bold mt-4 mb-3">{{member.name}}</h5>
                    <p class="text-uppercase position">{{member.position}}</p>
                </mdb-col>
            </mdb-row>

<!--            <div v-for="item in pageOfItems" :key="item.id">{{item.name}}</div>-->


        </mdb-container>
    </section>
</template>

<script>
    import Vue from 'vue';
    import {mdbContainer, mdbRow, mdbCol} from 'mdbvue';
    // import VuePaginate from 'vue-paginate'
    // import Paginate from 'vuejs-paginate'
    // Vue.component('paginate', Paginate)
    import JwPagination from 'jw-vue-pagination';
    Vue.component('jw-pagination', JwPagination);

    const customStyles = {
        ul: {
            // border: '2px solid red'
        },
        li: {
            display: 'inline-block',
            // border: '2px dotted green'
        },
        a: {
            color: 'white'
        }
    };

    const customLabels = {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
    };



    export default {
        name: 'Members',
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            JwPagination,
        },

        computed: {
            computedMemWPI () {
                return Object.values(this.$parent.membersWPI);
            }
        },


        data() {
            return {
                memWPI : [] ,
                memWPIPaginate: [],
                customStyles,
                customLabels
            };
        },
        methods: {
            onChangePage(pageOfItems) {
                // update page of items
                this.memWPIPaginate = pageOfItems;
            }
        }
    }
</script>

<style scoped>
    .rounded-circle {
        max-width: 150px;
        max-height: 150px;
        min-width: 150px;
        min-height: 150px;
    }

    .position {
        color: ghostwhite;
    }

    .gradient {
        background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
        background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    }

    @media (max-width: 700px) {
        .mb-lg-0 {
            text-align: center;
        }
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .wpi-members::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    .wpi-members {
        /*max-height: 520px;*/
        /*overflow-y: scroll;*/
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    .paginate-list {
        /*width: 159px;*/
        margin: 0 auto;
        text-align: left;
    }
    .paginate-list li {
        display: block;
    }
    .paginate-list li:before {
        content: '⚬ ';
        font-weight: bold;
        color: slategray;
    }
    .paginate-links.items {
        user-select: none;
    }
    .paginate-links.items a {
        cursor: pointer;
    }
    .paginate-links.items li.active a {
        font-weight: bold;
    }
    .paginate-links.items li.next:before {
        content: ' | ';
        margin-right: 13px;
        color: #ddd;
    }
    .paginate-links.items li.disabled a {
        color: #ccc;
        cursor: no-drop;
    }

</style>
